<template>
  <div class="update-password">
    <yd-cell-item>
      <span slot="left">旧密码：</span>
      <input slot="right" type="password" v-model="oldpassword" placeholder="请输入旧密码">
    </yd-cell-item>

    <yd-cell-item>
      <span slot="left">新密码：</span>
      <input slot="right" type="password" v-model="password" placeholder="请输入新密码">
    </yd-cell-item>

    <yd-cell-item>
      <span slot="left">确认新密码：</span>
      <input slot="right" type="password" v-model="realpassword" placeholder="请输入确认新密码">
    </yd-cell-item>
    <yd-button type="primary" size="large" @click.native="changePassword()" v-preventReClick>修改密码</yd-button>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'changePassword',
  data () {
    return {
      oldpassword: '',
      password: '',
      realpassword: ''
    }
  },
  methods: {
    changePassword () {
      if (this.password !== this.realpassword) {
        this.$dialog.toast({
          mes: '请确认新密码是否相同'
        })
        return false
      }
      let data = {
        oldpassword: this.oldpassword,
        password: this.password,
        uid: this.$store.state.uid
      }
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
      axios
        .post('/user/update-password', data)
        .then(res => {
          res = res.data
          if (res.status) {
            this.$dialog.toast({
              mes: '修改成功'
            })
            this.$router.push({path: '/' + this.$route.params.id + '/setting'})
          } else {
            this.$dialog.toast({
              mes: res.msg
            })
          }
        }).catch(res => {
        })
    }
  },
  mounted () {
  }
}
</script>

<style lang="stylus" scoped>
  .update-password
    margin 25px
</style>



// WEBPACK FOOTER //
// src/views/template1/changePassword.vue